import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Layout from "../../components/Layout.js";

const GstMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowAlphaNumeric = (value) => value.replace(/[^a-zA-Z0-9 ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const [entryDate, setEntryDate] = useState("");
  const [Gstnature, setGstnature] = useState("");
  const [Descripition, setDescripition] = useState("");
  const [RefBk, setRefBk] = useState("");
  const [RefBklist, setRefBklist] = useState([]);

  useEffect(() => {
    const fetchRefBkList = async () => {
      try {
        const response = await apiFetch(
          "/api/gstmaster/refbk"
        );
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        console.log("📌 RefBk dropdown data:", data);
        if (Array.isArray(data)) setRefBklist(data);
      } catch (err) {
        console.error("❌ Error fetching RefBk list:", err);
      }
    };

    fetchRefBkList();
  }, []);

  const handleExit = () => {
    navigate("/gst/grid");
  };

  const handleSave = async () => {
    try {
      console.log("📤 Sending data:", {
        entryDate,
        Gstnature,
        Descripition,
        RefBk,
      });

      const response = await apiFetch(
        "/api/gstmaster/insert",
        {
          method: "POST",
          body: JSON.stringify({ entryDate, Gstnature, Descripition, RefBk }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        alert(`✅ ${data.message}`);
        navigate("/gst/grid");
      } else {
        alert(`❌ Error: ${data.details || data.error}`);
      }
    } catch (err) {
      console.error("❌ Save failed:", err);
      alert("Error saving data");
    }
  };

  /*------------------- Styles--------------*/
  const pageContainerStyle = {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px",
    boxSizing: "border-box",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };

  const headerStyle = {
    border: "2px solid #8B1E3F",
    borderRadius: "6px",
    padding: "15px",
    marginBottom: "20px",
    textAlign: "center",
    background: "#8B1E3F",
    fontWeight: "bold",
    fontSize: "1.5rem",
    color: "#fff",
  };

  const rowStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "15px",
    marginBottom: "15px",
  };

  const columnStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const inputStyle = {
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
  };

  const buttonContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "10px",
    marginTop: "20px",
  };

  const buttonStyle = (bgColor) => ({
    width: "20%",
    padding: "12px 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    textAlign: "center",
    fontWeight: "bold",
  });

  const labelStyle = {
    fontWeight: "bold",
    marginBottom: "5px",
  };

  return (
    <Layout>
      <div style={pageContainerStyle}>
        <div style={containerStyle}>
          <div style={headerStyle}>Gst Master</div>

          <div style={rowStyle}>
            <div style={columnStyle}>
              <label style={labelStyle}>Date</label>
              <input
                type="date"
                value={entryDate}
                onChange={(e) => setEntryDate(e.target.value)}
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>GST Nature</label>
              <input
                type="text"
                value={Gstnature}
                onChange={(e) =>
                  setGstnature(allowAlphaNumeric(e.target.value))
                }
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Descripition</label>
              <input
                type="text"
                value={Descripition}
                onChange={(e) =>
                  setDescripition(allowAlphaNumeric(e.target.value))
                }
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Refbk</label>
              <select
                value={RefBk}
                onChange={(e) => setRefBk(e.target.value)}
                style={inputStyle}
              >
                <option value="">Select Account Name</option>
                {Array.isArray(RefBklist) &&
                  RefBklist.map((sch, index) => (
                    <option key={index} value={sch.value}>
                      {sch.value}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div style={buttonContainerStyle}>
            <button style={buttonStyle("#4caf50")} onClick={handleSave}>
              Save
            </button>

            <button style={buttonStyle("#ff9800")}>Update</button>

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default GstMasterDetailsDesign;
